import React from 'react';

import type IconBuilder from '~/components/patterns/icons/builders/iconsData/IconBuilder';



const TwitterCardsIconBuilder: IconBuilder = {
	icon: ({ color = '#964FA5', size }) => {
		// SVG taken from https://icons.getbootstrap.com/icons/twitter-x/
		// with original size of 16x16 scaled to 60x60
		return (
			<g
				fill="none"
				fillRule="evenodd"
				stroke="none"
				strokeWidth="1"
			>
				<g
					id="social-twitter"
					transform="translate(14, 14) scale(0.55)"
				>
					<path
						d="M 47.25 2.8125 L 56.453125 2.8125 L 36.351562 25.84375 L 60 57.1875 L 41.484375 57.1875 L 26.984375 38.175781 L 10.390625 57.1875 L 1.183594 57.1875 L 22.683594 32.550781 L 0 2.8125 L 18.984375 2.8125 L 32.09375 20.1875 L 47.253906 2.8125 Z M 44.023438 51.667969 L 49.125 51.667969 L 16.210938 8.042969 L 10.742188 8.042969 Z M 44.023438 51.667969"
						id="Stroke-1366"
						stroke={color}
						strokeLinecap="round"
						strokeLinejoin="round"
						strokeWidth={(60 / size) * 2}
					/>
				</g>
			</g>
		);
	},
	viewBoxHeight: 60,
	viewBoxWidth: 60,
};



export default TwitterCardsIconBuilder;

